import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import logo from "../../../../src/assets/admin/img/logos/white_logo.png";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectRoutes, selectRole } from '../../../redux/slices/authSlice';
import { STAFF_ROLE } from '../../../utils/Constants';

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const routes = useSelector(selectRoutes);
  const role = useSelector(selectRole);

  const isSuperAdmin = Array.isArray(role)
    ? role.includes(STAFF_ROLE.SUPER_ADMIN)
    : role === STAFF_ROLE.SUPER_ADMIN;

  const can = (route) => isSuperAdmin || routes.includes(route);

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = () => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = () => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img src={logo} className="header-brand-img icon-logo" alt="logo" style={{ height: "auto", width: "4rem" }} id="logo_short" />
          <img src={logo} className="header-brand-img desktop-logo rounded" style={{ height: "auto", width: "6rem" }} alt="logo" id="logo_full" />
        </a>
      </div>

      <div className="main-sidebar-body">
        <ul className="nav">
          {
            can("/admin/dashboard") && (
              <li className={"nav-item" + (loc.pathname === "/admin/dashboard" ? " active" : "")}>
                <Link className="nav-link" to="/admin/dashboard">
                  <span className="shape1"></span>
                  <span className="shape2"></span>
                  <i className="fa fa-home sidemenu-icon"></i>
                  <span className="sidemenu-label">{t("sidebar_link_dashboard")}</span>
                </Link>
              </li>
            )
          }
          {/* CMS */}
          {(can("/admin/cms/pages/list") || can("/admin/cms/banner/list") ||
            can("/admin/cms/default-email-template/list") || can("/admin/cms/sms-template/list") ||
            can("/admin/cms/settings") || can("/admin/cms/faq-management/faq/list")) && (
              <li className={`nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")}>
                <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                  <span className="shape1"></span>
                  <span className="shape2"></span>
                  <i className="fa fa-cogs sidemenu-icon"></i>
                  <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
                  <i className="angle fe fe-chevron-right"></i>
                </a>
                <ul className="nav-sub">
                  {can("/admin/cms/pages/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/pages/list/1">{t("sidebar_link_pages")}</Link>
                    </li>
                  )}
                  {can("/admin/cms/banner/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/banner") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/banner/list/1">{t("sidebar_link_banners")}</Link>
                    </li>
                  )}
                  {can("/admin/cms/default-email-template/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/default-email-template") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/default-email-template/list/1">{t("sidebar_link_email_template")}</Link>
                    </li>
                  )}
                  {can("/admin/cms/sms-template/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/sms-template") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/sms-template/list/1">{t("SMS Template")}</Link>
                    </li>
                  )}
                  {can("/admin/cms/settings") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/settings") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/settings">{t("sidebar_link_global_settings")}</Link>
                    </li>
                  )}
                  {can("/admin/cms/faq-management/faq/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/cms/faq-management") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/cms/faq-management/faq/list/1">{t("sidebar_link_faq")}</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

          {/* Babe User */}
          {can("/admin/babe-user/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/babe-user") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/babe-user/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-user sidemenu-icon"></i>
                <span className="sidemenu-label">{t("link_babe_user")}</span>
              </Link>
            </li>
          )}

          {/* Babe Associate */}
          {can("/admin/babe-associate/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/babe-associate") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/babe-associate/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-user-plus sidemenu-icon"></i>
                <span className="sidemenu-label">{t("link_babe_associate")}</span>
              </Link>
            </li>
          )}

          {/* Sub Admin */}
          {isSuperAdmin && (
            <li className={`nav-item ` + (loc.pathname.includes("/staff") || loc.pathname.includes("/role") || loc.pathname.includes("/permission") ? "show active" : "")}>
              <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-user-cog sidemenu-icon"></i>
                <span className="sidemenu-label">{t("label_sub_admin")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                <li className={`nav-sub-item ${loc.pathname.includes("/staff") ? "active" : ""}`}>
                  <Link className="nav-sub-link" to="/admin/staff/list/1">{t("Sub Admin")}</Link>
                </li>
                <li className={`nav-sub-item ${loc.pathname.includes("/role") ? "active" : ""}`}>
                  <Link className="nav-sub-link" to="/admin/role/list/1">{t("label_role")}</Link>
                </li>
                <li className={`nav-sub-item ${loc.pathname.includes("/permission") ? "active" : ""}`}>
                  <Link className="nav-sub-link" to="/admin/permission/list/1">{t("label_permission")}</Link>
                </li>
              </ul>
            </li>
          )}

          {/* Appointments */}
          {can("/admin/appointments/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/appointments") && !loc.pathname.includes("/pending") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/appointments/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-calendar-check-o sidemenu-icon"></i>
                <span className="sidemenu-label">{t("link_appointment_list")}</span>
              </Link>
            </li>
          )}

          {/* Pending Appointments */}
          {can("/admin/pending-appointments/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/pending-appointments") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/pending-appointments/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-calendar-check-o sidemenu-icon"></i>
                <span className="sidemenu-label">{t("link_pending_appointment_list")}</span>
              </Link>
            </li>
          )}

          {/* Ratings */}
          {can("/admin/ratings/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/ratings") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/ratings/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-star sidemenu-icon"></i>
                <span className="sidemenu-label">{t("link_ratings")}</span>
              </Link>
            </li>
          )}

          {/* Jobs */}
          {can("/admin/jobs-management/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/jobs-management") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/jobs-management/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-search sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Searched Jobs")}</span>
              </Link>
            </li>
          )}

          {/* Subscriptions */}
          {(can("/admin/subscription/subscription-plan/list") ||
            can("/admin/subscription/user-subscription-plan/list") ||
            can("/admin/subscription/transaction/list")) && (
              <li className={`nav-item ` + (loc.pathname.includes("/subscription") ? "show active" : "")}>
                <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                  <span className="shape1"></span>
                  <span className="shape2"></span>
                  <i className="fa fa-shopping-cart sidemenu-icon"></i>
                  <span className="sidemenu-label">Subscriptions</span>
                  <i className="angle fe fe-chevron-right"></i>
                </a>
                <ul className="nav-sub">
                  {can("/admin/subscription/subscription-plan/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/subscription/subscription-plan") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/subscription/subscription-plan/list/1">Subscription plans</Link>
                    </li>
                  )}
                  {can("/admin/subscription/user-subscription-plan/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/subscription/user-subscription-plan/list") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/subscription/user-subscription-plan/list/1">{t("label_user_subscriptions")}</Link>
                    </li>
                  )}
                  {can("/admin/subscription/transaction/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("/transaction/list") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/subscription/transaction/list/1">{t("label_transactions")}</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

          {/* Promotions */}
          {can("/admin/promotion-management/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/promotion-management") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/promotion-management/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-tag sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Promotions")}</span>
              </Link>
            </li>
          )}

          {/* Inquiries */}
          {can("/admin/inquiries/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/inquiries") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/inquiries/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-question-circle sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_inquiries")}</span>
              </Link>
            </li>
          )}

          {/* Prelaunch */}
          {can("/admin/prelaunch/list") && (
            <li className={`nav-item ` + (loc.pathname.includes("/prelaunch") ? "show active" : "")}>
              <Link className="nav-link" to="/admin/prelaunch/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-users sidemenu-icon"></i>
                <span className="sidemenu-label">Prelaunch Inquiries</span>
              </Link>
            </li>
          )}

          {/* Reports */}
          {(can("/admin/reports/associate-reports/list") || can("/admin/reports/babe-reports/list") ||
            can("/admin/reports/revenue-reports/list") || can("/admin/reports/service-reports/list")) && (
              <li className={`nav-item ` + (loc.pathname.includes("/reports") ? "show active" : "")}>
                <a className="nav-link with-sub submenu" onClick={toggleDropdown} href="/">
                  <span className="shape1"></span>
                  <span className="shape2"></span>
                  <i className="fa fa-clipboard sidemenu-icon"></i>
                  <span className="sidemenu-label">Reports</span>
                  <i className="angle fe fe-chevron-right"></i>
                </a>
                <ul className="nav-sub">
                  {can("/admin/reports/associate-reports/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("associate-report") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/reports/associate-reports/list/1">Associate Reports</Link>
                    </li>
                  )}
                  {can("/admin/reports/babe-reports/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("babe-reports") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/reports/babe-reports/list/1">Babe Reports</Link>
                    </li>
                  )}
                  {can("/admin/reports/revenue-reports/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("revenue-reports") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/reports/revenue-reports/list/1">Revenue Reports</Link>
                    </li>
                  )}
                  {can("/admin/reports/service-reports/list") && (
                    <li className={`nav-sub-item ${loc.pathname.includes("service-reports") ? "active" : ""}`}>
                      <Link className="nav-sub-link" to="/admin/reports/service-reports/list/1">Service Reports</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

        </ul>
      </div>
    </div>
  );
};

export default SideBar;